<div [attr.id]="checkId()"
    [attr.tabindex]="disabled ? -1 : 0"
    role="button"
    [attr.aria-label]="label"
    class="sis-header-icon tyl-button"
    [ngStyle]="{'cursor' : (disabled ? '' : 'pointer'), 'padding': (noPadding ? '0px' : '')}"
    (click)="onClick()"
    (keydown)="onKeydown($event)">
    <div style="margin-top:2px;text-align:center;">
        <img src="./assets/images/{{image}}" [ngStyle]="{'width' : iconWidth != undefined ? iconWidth + 'px' : ''}" *ngIf="(!disabled || !disabledImage) && image"/>
        <img src="./assets/images/{{disabledImage}}" [ngStyle]="{'width' : iconWidth != undefined ? iconWidth + 'px' : ''}" *ngIf="disabled && disabledImage"/>
    </div>
    <div *ngIf="showLabel"
        style="max-height:15px;"
        [ngStyle]="{
            'text-align':'center',
            'color': (textColor ? textColor : disabled ? '#bfbfbf' : 'inherit')}"
        >
        {{label | translate}}
    </div>
</div>
